import { Routes } from '@angular/router';
import { MsalGuard } from '@azure/msal-angular';
import { PageNotFoundComponent } from './shared/components/page-not-found/page-not-found.component';
import { LogOutComponent } from './shared/components/log-out/log-out.component';
import { FileDownloadComponent } from './shared/components/file-download/file-download.component';
import { HomeComponent } from './features/home/home.component';

export const routes: Routes = [
  {
    path: 'engagements',
    loadChildren: () => import('./features/engagement/engagement.routes').then(m => m.ENGAGEMENT_ROUTES),
    canActivate: [MsalGuard]
  },
  {
    path: 'UploadFiles/:id/:type/:fileId',
    component: FileDownloadComponent,
    canActivate: [MsalGuard],
  },
  {
    path: '',
    redirectTo: 'home',
    pathMatch: 'full',
  },
  {
    path: 'home',
    component: HomeComponent,
    canActivate: [MsalGuard]
  },
  {
    path: 'logout',
    component: LogOutComponent,
  },
  {
    path: '**',
    component: PageNotFoundComponent,
  },
];
